import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Account, LOGIN_MIN_LENGTH, PASSWORD_MIN_LENGTH, SignUpAccount } from '../../model/authentication/account.model';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({
    'Accept': 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded'
  })
};

const httpOptionsDefault = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService extends BaseService {

  constructor(protected httpClient: HttpClient) {
    super();
  }

  login(account: Account): Observable<any> {
    if (!account.account || !account.password) {
      return;
    }
    const body = new HttpParams()
      .set('account', account.account)
      .set('password', account.password)
      .set('grant_type', 'password');

    return this.httpClient.post<any>(this.apiUrl + 'login', body.toString(), httpOptions);
  }

  signUp(account: SignUpAccount) {
    account.device_os = '1';
    return this.httpClient.post(this.apiUrl + 'register', account, httpOptionsDefault);
  }

  forgotPwd(forgotAccount: any) {
    const param = { email: forgotAccount };
    return this.httpClient.post(this.apiUrl + 'forgotPassword', param, httpOptionsDefault);
  }

  // Validate function
  isInvalidAccount(account: Account) {
    return !account.account || account.account.length < LOGIN_MIN_LENGTH
      || !account.password || account.password.length < PASSWORD_MIN_LENGTH;
  }

  isInvalidSignUpAccount(signUpAccount: SignUpAccount) {
    return !signUpAccount.full_name
      || !signUpAccount.email
      || !this.validateEmail(signUpAccount.email)
      || !signUpAccount.password
      || !signUpAccount.phone_number;
  }

  isInvalidForgotAccount(forgotAccount: any) {
    return !forgotAccount || !this.validateEmail(forgotAccount);
  }

  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
}
